/**
 * file-exchange-service routes. The service name is hidden from the consumer
 * surface (TO-632, api-conventions §(a)): paths use the de-prefixed consumer
 * nouns `/imports`, `/import-definitions`, `/logical-files` and (platform-only)
 * `/admin/tenants/{tenantId}/sftp-connectors`. Each config resource exists twice:
 * under the caller's own tenant, and under `/admin/tenants/{tenantId}` for a
 * Super-Admin. Runtime import execution is the single merged `/imports/{id}`
 * surface, keyed on one `{id}` (TO-632 §4).
 */
export const FileExchangeRoutes = {
	listFiles: '/logical-files',
	getFile: '/logical-files/{fileType}',
	putFile: '/logical-files/{fileType}',
	listFileVersions: '/logical-files/{fileType}/versions',
	adminListFiles: '/admin/tenants/{tenantId}/logical-files',
	adminGetFile: '/admin/tenants/{tenantId}/logical-files/{fileType}',
	adminPutFile: '/admin/tenants/{tenantId}/logical-files/{fileType}',
	adminListFileVersions: '/admin/tenants/{tenantId}/logical-files/{fileType}/versions',
	// Import-definition designer (TO-400): read-only, synchronous, nothing stored.
	// Nested under the definitions noun (TO-632).
	importDesignerInspect: '/import-definitions/designer/inspect',
	importDesignerPreview: '/import-definitions/designer/preview',
	importDesignerDryRun: '/import-definitions/designer/dry-run',
	adminImportDesignerInspect: '/admin/tenants/{tenantId}/import-definitions/designer/inspect',
	adminImportDesignerPreview: '/admin/tenants/{tenantId}/import-definitions/designer/preview',
	adminImportDesignerDryRun: '/admin/tenants/{tenantId}/import-definitions/designer/dry-run',
	// SFTP connectors (TO-393): Super-Admin only — there is no own-tenant connector route.
	adminListConnectors: '/admin/tenants/{tenantId}/sftp-connectors',
	adminCreateConnector: '/admin/tenants/{tenantId}/sftp-connectors',
	adminGetConnector: '/admin/tenants/{tenantId}/sftp-connectors/{id}',
	adminUpdateConnector: '/admin/tenants/{tenantId}/sftp-connectors/{id}',
	adminDeleteConnector: '/admin/tenants/{tenantId}/sftp-connectors/{id}',
	adminTestConnector: '/admin/tenants/{tenantId}/sftp-connectors/{id}/test',
	adminConfirmConnectorHostKey: '/admin/tenants/{tenantId}/sftp-connectors/{id}/host-key/confirm',
	// Import monitoring (TO-399): own tenant only, read-only. The merged runtime
	// surface — one `/imports/{id}`, the sole canonical execution read (TO-632 §4).
	listImportExecutions: '/imports',
	getImportExecution: '/imports/{id}',
	listImportExecutionChanges: '/imports/{id}/changes',
	getImportErrorsReportLink: '/imports/{id}/errors-report',
	getImportOriginalFileLink: '/imports/{id}/original-file',
}
